<template>
    <div style="width: 100%;">
        <div style="margin-bottom: 7px;">
            <user-avatar
                    :img="userAvatar"
                    :userName="userName"
            />
        </div>
        <v-btn flat icon color="blue-grey lighten-4"
               @click="onSignOutButtonOutClick"
               title="Выйти"
        >
            <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import Vue from 'vue'

    import UserAvatar from '@/components/user-avatar/user-avatar'

    import firebase from 'firebase/app'
    import 'firebase/auth'

    export default {
        props: {},
        data() {
            return {
                userAvatar: firebase.auth().currentUser.photoURL,
                userName: firebase.auth().currentUser.displayName
            }
        },
        computed: {},
        methods: {
            onSignOutButtonOutClick() {
                firebase.auth().signOut();
                window.location.href = '/auth';
            }
        },

        components: {
            UserAvatar
        }
    }
</script>

<style scoped>

</style>
